import { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import "./Header.scss";
import { NavLink } from "react-router-dom";
import darkLogo from "../../Img/txlogo.png";
import lightlogo from "../../Img/txlogo.png";
import { ThemeContext } from "../DarkMode/ThemeProvider";
import Avatar from "@mui/material/Avatar";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Darkmode from "../DarkMode/Darkmode";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Popover from "@mui/material/Popover";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FolderIcon from "@mui/icons-material/Folder";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import SendIcon from "@mui/icons-material/Send";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import SecurityIcon from "@mui/icons-material/Security";
import more1 from "../../Img/more-1.png";
import more2 from "../../Img/more-2.png";
import more3 from "../../Img/more-3.png";
import more4 from "../../Img/more-4.png";
import more5 from "../../Img/more-5.png";
import more6 from "../../Img/more-6.png";
import more7 from "../../Img/more-7.png";
import more8 from "../../Img/more-8.png";
import more9 from "../../Img/more-9.png";
import SettingsIcon from "@mui/icons-material/Settings";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import HouseIcon from "@mui/icons-material/House";
import BarChartIcon from "@mui/icons-material/BarChart";
import LogoutIcon from "@mui/icons-material/Logout";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import downloadicon from "../../Img/dwns.svg";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Badge, Link, MenuItem, MenuList, Paper } from "@mui/material";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import usercalls from "../../Axios";
import consts from "../../constant";
import { useUserData } from "../../Contexts/UserContext";
import Context from "../../Context";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { toast } from "react-toastify";
import { HistoryRounded, Verified } from "@mui/icons-material";

const drawerWidth = "100%";

const headers = [
  {
    title: "Market",
    path: "/market",
  },
  {
    title: "Trade",
    path: `/trade/${consts?.MainPair}?type=spot`,
    // path:"/trade"
  },

  {
    title: "Future",
    path: `/future/${consts?.FutureMainPair}`,
    // path:"/trade"
  },

  {
    title: "Buy Crypto",

    path: "/instant",
  },
];
const headersMob = [
  {
    title: "Market",
    path: "/market",
  },
  {
    title: "Trade",
    path: `/trade/${consts?.MainPair}?type=spot`,
  },

  {
    title: "Future",
    path: `/future/${consts?.FutureMainPair}`,
  },

  {
    title: "Buy Crypto",
    path: "/instant",
  },
  {
    title: "Assets",
    path: "/assets",
  },
  {
    title: "Deposit",
    path: "/deposit",
  },
  {
    title: "Withdraw",
    path: "/withdraw",
  },
  {
    title: "History",
    path: "/history",
  },
];

const moreFeatures = [
  {
    img: more1,
    title: "Compare Other Crypto Exchanges",
    content: "Explore the top coin price in Top Exchanges",
    path: "/underconstruction",
  },
  {
    img: more2,
    title: "Right Exchange Identification",
    content: "Choose the Best Exchange for You",
    path: "/underconstruction",
  },
  {
    img: more3,
    title: "Choose the Best Exchange for You",
    content: "Cast Your Vote and Support Dreamster-Exchange",
    path: "/underconstruction",
  },
  {
    img: more4,
    title: "Voting for Dreamster-Exchange",
    content: "Cast Your Vote and Support Dreamster-Exchange",
    path: "/underconstruction",
  },
  {
    img: more5,
    title: "Probinar Academy",
    content: "Master Blockchain with Probinar Academy",
    path: "/underconstruction",
  },
  {
    img: more6,
    title: "About Us",
    content: "Learn More About Dreamster-Exchange",
    path: "/underconstruction",
  },
  {
    img: more7,
    title: "Our Team",
    content: "Meet the Experts Behind Dreamster-Exchange",
    path: "/underconstruction",
  },
  {
    img: more8,
    title: "Contact Us",
    content: "Get in Touch with Dreamster-Exchange Support",
    path: "/support",
  },
  {
    img: more9,
    title: "Community",
    content: "Join and Engage with Crypto Enthusiasts",
    path: "/underconstruction",
  },
];

const settings = [
  { icon: <GridViewRoundedIcon />, name: "Dashboard", url: "/dashboard" },
  // { icon: <LocalActivityIcon />, name: "Reward Hub", url: "/reward-hub" },
  // { icon: <PersonAddAlt1Icon />, name: "Referral", url: "/referral" },
  { icon: <AccountBalanceWalletRoundedIcon />, name: "Assets", url: "/assets" },
  { icon: <HistoryRounded />, name: "History", url: "/history" },
  { icon: <DocumentScannerIcon />, name: "Kyc", url: "/Kycverify" },
  { icon: <SecurityIcon />, name: "Security", url: "/security" },
  { icon: <LogoutIcon />, name: "Logout", url: "/login", logout: true },
];

function DrawerAppBar() {
  const { pathname } = useLocation();
  const currentPath = pathname === "/" ? "/" : "/" + pathname.split("/")[1];
  const navigate = useNavigate();
  const [token, setToken] = useState(null);
  const lastIndex = headers.length - 1;
  const { userData, setHeaderRenderCount, setUserData } = useUserData();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isLightMode, handleDarkmode } = useContext(ThemeContext);
  const [anchorE2, setAnchorE2] = useState(null);
  const open2 = Boolean(anchorE2);
  const path = usercalls();
  const handleNotifyClick = (event) => {
    setAnchorE2(event.currentTarget);
    // setUp(true);
  };
  const handleNotifyClose = () => {
    setAnchorE2(null);
    // setUp(false);
  };
  const { setSelcOrderBook } = useContext(Context);

  const [notification, setNotification] = useState([]);
  const [notificationType, setNotificationType] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const handleClickProfile = (event) => {
    setAnchorElProfile(event.currentTarget);
  };
  const handleCloseProfile = () => {
    setAnchorElProfile(null);
  };
  const openProfile = Boolean(anchorElProfile);
  const idProfile = openProfile ? "simple-popover" : undefined;
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const handleDrawerClose = () => {
    setMobileOpen(false);
    setOpen1(false);
  };
  const [open1, setOpen1] = useState(false);

  const handleClickList = () => {
    setOpen1(!open1);
  };

  const theme = useTheme();
  const large = useMediaQuery(theme.breakpoints.up("lg"));
  const mdium = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    setToken(window.localStorage.getItem("Rikosta"));
    setHeaderRenderCount(Math.random(6));
  }, []);

  const getNotification = async () => {
    try {
      const url = `${consts.BackendUrl}/admin/getnotifications`;
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      // console.log(result, 'result');
      if (result.success) {
        setNotification(result?.result);
      } else {
        setNotification([]);
      }
    } catch (error) {
      console.log("🚀 ~ getProfile ~ error:", error);
    }
  };

  const clearNotifications = async (detail) => {
    try {
      const url = `${consts.BackendUrl}/admin/clearnotifications`;
      const payload = { for: detail };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      // console.log(result, 'result');
      // if (result.success) {
      //   setNotification(result?.result);
      // } else {
      //   setNotification([]);
      // }
    } catch (error) {
      console.log("🚀 ~ getProfile ~ error:", error);
    }

    // try {
    //   const { data } = await Axios.post(
    //     '/admin/clearnotifications',
    //     { for: detail },
    //     {
    //       headers: {
    //         Authorization: `Bearer ${window.localStorage.getItem("Rikosta")}`,
    //       },
    //     }
    //   );
    // } catch (error) {
    //   console.log(error)
    // }
  };

  useEffect(() => {
    if (token) {
      getNotification();
    }
  }, [token]);

  useEffect(() => {
    setNotificationType([
      ...new Set(notification.map((obj) => obj._id).filter(Boolean)),
    ]);
  }, [notification]);

  const overallCount = notification.reduce(
    (notif, acc) => notif + acc.count,
    0
  );

  const clearNotificationshandler = () => {
    handleNotifyClose();
    setTimeout(() => {
      getNotification();
    }, 500);
  };

  const handleNotificationNavigation = (data) => {
    // if (data == "P2P") {
    //   navigate(`/p2p`);
    //   clearNotifications("P2P");
    //   clearNotificationshandler();
    // } else
    if (data == "KYC") {
      navigate(`/Kycverify`);
      clearNotifications("KYC");
      clearNotificationshandler();
    } else if (data == "Support") {
      navigate(`/support`);
      clearNotifications("Support");
      clearNotificationshandler();
    } else if (data == "Withdrawal") {
      clearNotifications("Withdrawal");
      navigate(`/withdraw`);
      clearNotificationshandler();
    } else if (data == "Deposit") {
      clearNotifications("Deposit");
      navigate(`/assets`);
      clearNotificationshandler();
    } else if (data == "Trade") {
      clearNotifications("Trade");
      navigate(`/history`);
      clearNotificationshandler();
    }
  };

  const profile = (
    <>
      <Darkmode />
      <div className="display-2 profile-mob">
        {/* <ArrowRightAltIcon
          onClick={handleDrawerClose}
          sx={{ display: { xs: "block", lg: "none" }, color: "#fff" }}
        /> */}
      </div>
    </>
  );
  const loginBtn = (
    <>
      <div className="reg-h-btn display-1">
        <Button variant="contained" onClick={() => navigate("/register")}>
          Sign up
        </Button>
      </div>
      <div className="login-h-btn display-1">
        <Button variant="contained" onClick={() => navigate("/login")}>
          Sign in
        </Button>
      </div>
    </>
  );

  // const getUserdata = async () => {
  //   try {
  //     const response = await path.getCallWithToken({
  //       url: `${consts.BackendUrl}/getUserData`,
  //     });
  //     const result = await response.json();

  //     if (result.success) {
  //       setUserData(result.result);
  //     }
  //   } catch (error) {
  //     console.log("🚀 ~ getUserdata ~ error:", error);
  //   }
  // };

  // useEffect(() => {
  //   getUserdata();
  // }, []);

  const drawer = (
    <Box sx={{ textAlign: "center" }}>
      <div className="display-2 profile-mob p-10">
        <div className="text-left p-20">
          <Darkmode />
        </div>
        <ArrowRightAltIcon
          onClick={handleDrawerClose}
          sx={{
            display: { xs: "block", lg: "none" },
            color: "var(--clr-font)",
          }}
        />
      </div>
      <div
        className="display-2 p-10"
        onClick={() => {
          navigate("/dashboard");
        }}
      >
        <div className="display-1 profile-dropdown-user">
          <Avatar
            alt="Remy Sharp"
            src={userData?.profilePicture}
            // onClick={handleClickProfile}
          />
          <div>
            <Typography
              variant="body1"
              gutterBottom
              sx={{ marginBottom: "0 !important" }}
            >
              {userData?.name}
            </Typography>
            <p>{userData?.country}</p>
          </div>
        </div>
        <KeyboardArrowRightIcon sx={{ color: "var(--clr-font)" }} />
      </div>

      <List>
        {headersMob.map((item, i) => (
          <ListItem key={i} disablePadding>
            <ListItemButton
              sx={{ textAlign: "left", padding: "5px 20px" }}
              className={
                currentPath === "/"
                  ? "link-non-active"
                  : item.path === currentPath
                  ? "link-active"
                  : "link-non-active"
              }
              onClick={() => {
                navigate(item.path);
              }}
            >
              <ListItemText primary={item.title} />
              {/* {lastIndex === i && (open1 ? <ExpandLess /> : <ExpandMore />)} */}
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* <div className="display-2 p-20 header-login-btns">{loginBtn}</div> */}
      <div className="download-h-btn p-20 display-2">
        {/* <Link
          href="https://play.google.com/store/apps/details?id=com.application.Dreamster-Exchange"
          className="display-3"
        >
          <img src={downloadicon} />

        </Link> */}
      </div>
      <div className="display-1 p-10">
        {token != null ? (
          <div className="reg-h-btn display-1">
            <Button
              variant="contained"
              onClick={() => {
                window.localStorage.clear();
                navigate("/login");
              }}
            >
              Logout
            </Button>
          </div>
        ) : (
          loginBtn
        )}
      </div>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        className="header-appbar"
        sx={{ paddingBottom: "2px" }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <div className="display-1">
            {large ? (
              <div className="logo-new-h">
                <NavLink to="/">
                  <img src={!isLightMode ? lightlogo : darkLogo} />
                </NavLink>
              </div>
            ) : (
              <Avatar
                alt="profile-img"
                sx={{ cursor: "pointer" }}
                src={userData?.profilePicture}
                onClick={handleDrawerToggle}
                className="profile-icon"
                // onClick={}
              />
            )}

            <Box sx={{ display: { xs: "none", lg: "block" } }}>
              {headers.map((item, i) => (
                <Button
                  key={i}
                  sx={{ textTransform: "capitalize" }}
                  className={
                    currentPath === "/"
                      ? "link-non-active"
                      : item.path.includes(currentPath)
                      ? "link-active"
                      : "link-non-active"
                  }
                  onClick={(e) => {
                    // lastIndex === i ? handleClick(e) :
                    //  item.title.includes('Future') ? toast.success("coming soon") :
                    navigate(item.path);
                    // setSelcOrderBook([0])
                  }}
                >
                  {item.title}
                  {/* {lastIndex === i && <KeyboardArrowDownIcon />} */}
                </Button>
              ))}
            </Box>
          </div>

          {
            <div className="display-1" style={{ gap: "20px" }}>
              {token != null && (
                <div
                  className="display-1 add-fund cursor"
                  onClick={() => {
                    navigate("/deposit");
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="ic2_deposit">
                      <g id="shape">
                        <path
                          d="M8.66671 1.33341C8.66671 0.965225 8.36823 0.666748 8.00004 0.666748C7.63185 0.666748 7.33338 0.965225 7.33338 1.33341V8.39061L5.80478 6.86201C5.54443 6.60166 5.12232 6.60166 4.86197 6.86201C4.60162 7.12236 4.60162 7.54447 4.86197 7.80482L7.52864 10.4715C7.78899 10.7318 8.2111 10.7318 8.47145 10.4715L11.1381 7.80482C11.3985 7.54447 11.3985 7.12236 11.1381 6.86201C10.8778 6.60166 10.4557 6.60166 10.1953 6.86201L8.66671 8.39061V1.33341Z"
                          fill="#01BC8D"
                        ></path>
                        <path
                          d="M12.6366 5.36256C12.6305 5.35307 12.6246 5.34337 12.6188 5.33347C12.4347 5.01461 12.544 4.60689 12.8629 4.42279C13.1737 4.24331 13.5691 4.34265 13.7593 4.64322L13.7607 4.64235C14.3367 5.62842 14.6667 6.77569 14.6667 8.00006C14.6667 11.682 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.682 1.33337 8.00006C1.33337 6.7757 1.66343 5.62842 2.23942 4.64236L2.2408 4.64322C2.43102 4.34266 2.82635 4.24332 3.13722 4.42279C3.45608 4.60689 3.56533 5.01462 3.38123 5.33348C3.37554 5.34334 3.36963 5.353 3.36352 5.36246C2.92006 6.14032 2.66671 7.0406 2.66671 8.00006C2.66671 10.9456 5.05452 13.3334 8.00004 13.3334C10.9456 13.3334 13.3334 10.9456 13.3334 8.00006C13.3334 7.04064 13.08 6.1404 12.6366 5.36256Z"
                          fill="#01BC8D"
                        ></path>
                      </g>
                    </g>
                  </svg>
                  Add Funds
                </div>
              )}
              {token != null && large ? (
                <Avatar
                  alt="profile-img"
                  sx={{ cursor: "pointer" }}
                  src={userData?.profilePicture}
                  onClick={handleClickProfile}
                  // onMouseLeave={handleClickProfile}
                  className="profile-icon"
                />
              ) : null}
              {token != null && (
                <div className="notification">
                  <Badge badgeContent={+overallCount}>
                    <div className="cursor d-flex" onClick={handleNotifyClick}>
                      <svg
                        class="ICNotification_svg__icon"
                        viewBox="0 0 1024 1024"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="var(--clr-font)"
                      >
                        <path d="M844.704 410.4c0-179.552-145.536-325.088-325.088-325.088S194.528 230.848 194.528 410.4v316.96h-56.736a40.64 40.64 0 000 81.28h241.024a142.272 142.272 0 00281.568 0h241.024a40.64 40.64 0 000-81.28h-56.736V410.4zm-568.896 0a243.808 243.808 0 11487.616 0v316.96H275.808V410.4zm243.808 438.912c-26.528 0-49.12-16.96-57.472-40.64H577.12a60.992 60.992 0 01-57.472 40.64z"></path>
                      </svg>
                    </div>
                    {/* <NotificationsActiveIcon
                    sx={{ color: "#566FFF" }}
                    aria-describedby={"simple-popover"}
                    onClick={handleNotifyClick}
                  /> */}
                  </Badge>
                  <Popover
                    open={open2}
                    anchorEl={anchorEl}
                    onClose={handleNotifyClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <Paper sx={{ width: 200, maxWidth: "100%" }}>
                      <MenuList>
                        {notificationType.length > 0 ? (
                          notificationType.map((type, index) => (
                            <MenuItem
                              key={index}
                              onClick={() => handleNotificationNavigation(type)}
                            >
                              <ListItemText>{type}</ListItemText>
                              <Typography
                                variant="body2"
                                sx={{ color: "text.secondary" }}
                              >
                                {notification.map(
                                  (notif) => notif._id == type && notif.count
                                )}
                              </Typography>
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem>
                            <ListItemText style={{ textAlign: "center" }}>
                              No Notifications
                            </ListItemText>
                          </MenuItem>
                        )}
                      </MenuList>
                    </Paper>
                  </Popover>
                </div>
              )}

              {large && (
                <IconButton
                  className="menu-icon"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{
                    mr: 0,
                    display: { md: "flex", lg: "none", sm: "none" },
                  }}
                >
                  <MenuIcon
                    className="icon-inner x2"
                    sx={{
                      fill: "var(--clr-font)",
                      path: { fill: "var(--clr-font) !important" },
                    }}
                  />
                </IconButton>
              )}
              {token != null && <div>{profile}</div>}
              <div
                className="header-left gap-15"
                style={{ display: large ? "flex" : "none" }}
              >
                {token != null ? null : loginBtn}
                {/* {profile} */}
              </div>
            </div>
          }
        </Toolbar>
      </AppBar>

      {/* mobile menu */}

      {!mdium && (
        <AppBar
          position="fixed"
          color="primary"
          sx={{ top: "auto", bottom: 0 }}
        >
          <Toolbar
            sx={{ justifyContent: "space-between" }}
            className="mobile-menu-toolbar"
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => navigate(`/`)}
            >
              <HouseIcon
                sx={{ fill: pathname === "/" ? "#566FFF" : "var(--clr-font)" }}
              />
              <div className="mobile-menu-name">Home</div>
            </IconButton>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => navigate(`/market`)}
            >
              <BarChartIcon
                sx={{
                  fill: pathname === "/market" ? "#566FFF" : "var(--clr-font)",
                }}
              />
              <div className="mobile-menu-name">Market</div>
            </IconButton>
            <IconButton
              color="inherit"
              onClick={() => navigate(`/trade/${consts?.MainPair}`)}
            >
              <SwapHorizIcon
                sx={{
                  fill:
                    pathname === `/trade/${consts?.MainPair}`
                      ? "#566FFF"
                      : "var(--clr-font)",
                }}
              />
              <div className="mobile-menu-name">Trade</div>
            </IconButton>
            <IconButton
              color="inherit"
              onClick={() => navigate(`/future/${consts?.FutureMainPair}`)}
            >
              <TrendingUpIcon
                sx={{
                  fill:
                    pathname === `/future/${consts?.FutureMainPair}`
                      ? "#566FFF"
                      : "var(--clr-font)",
                }}
              />
              <div className="mobile-menu-name">Future</div>
            </IconButton>
            <IconButton color="inherit" onClick={() => navigate(`/assets`)}>
              <FolderIcon
                sx={{
                  fill: pathname === "/assets" ? "#566FFF" : "var(--clr-font)",
                }}
              />
              <div className="mobile-menu-name">Assets</div>
            </IconButton>
          </Toolbar>
        </AppBar>
      )}
      <nav>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              backgroundColor: "var(--clr-bcg)",
              color: "var(--clr-font)",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="more-popover"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div className="more-dropdown p-10">
          <div className="more-dropdown-main">
            <Typography variant="h5" gutterBottom>
              Features
            </Typography>
            {moreFeatures.slice(0, 5).map((row, i) => {
              return (
                <NavLink
                  to={row.path}
                  style={{ textDecoration: "none" }}
                  key={i}
                >
                  <div className="display-1 more-dropdown-block">
                    <div className="more-features-icon">
                      <img src={row.img} alt={row.img} />
                    </div>
                    <div className="more-features-content">
                      <Typography
                        variant="body1"
                        gutterBottom
                        sx={{ marginBottom: "0 !important" }}
                      >
                        {row.title}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        {row.content}
                      </Typography>
                    </div>
                  </div>
                </NavLink>
              );
            })}
          </div>
          <div className="more-dropdown-main">
            <Typography variant="h5" gutterBottom>
              Overview
            </Typography>

            {moreFeatures.slice(5, 9).map((row, i) => {
              return (
                <NavLink
                  to={row.path}
                  style={{ textDecoration: "none" }}
                  key={i}
                >
                  <div className="display-1 more-dropdown-block">
                    <div className="more-features-icon">
                      <img src={row.img} alt={row.img} />
                    </div>
                    <div className="more-features-content">
                      <Typography
                        variant="body1"
                        gutterBottom
                        sx={{ marginBottom: "0 !important" }}
                      >
                        {row.title}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        {row.content}
                      </Typography>
                    </div>
                  </div>
                </NavLink>
              );
            })}
          </div>
        </div>
      </Popover>
      <Popover
        id={idProfile}
        open={openProfile}
        anchorEl={anchorElProfile}
        onClose={handleCloseProfile}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className="profile-popover"
      >
        <div className="profile-dropdown p-10">
          <div className="display-1 profile-dropdown-user">
            <Avatar
              alt="Remy Sharp"
              src={userData?.profilePicture}
              // onClick={handleClickProfile}
            />
            <div>
              <Typography
                variant="body1"
                gutterBottom
                sx={{ marginBottom: "0 !important" }}
              >
                {userData?.name}
              </Typography>
              <p>{userData?.country}</p>
            </div>
          </div>
          {settings.map((row, i) => {
            if (row.name === "Logout") {
              return (
                <a className="profile-drowpdown-item logout-dpd" key={i}>
                  <div className="profile-icon d-flex">{row.icon}</div>
                  <div
                    className="profile-content"
                    onClick={() => {
                      if (row?.logout) {
                        window.localStorage.clear();
                        setUserData(null);
                        navigate("/login");
                      }
                    }}
                  >
                    {row?.name}
                  </div>
                </a>
              );
            } else {
              return (
                <NavLink
                  to={row.url}
                  style={{ textDecoration: "none" }}
                  className="profile-drowpdown-item"
                  key={i}
                >
                  <div className="profile-icon d-flex">{row.icon}</div>
                  <div className="profile-content">
                    <Typography
                      variant="body1"
                      gutterBottom
                      sx={{ marginBottom: "0 !important" }}
                    >
                      {row.name}
                    </Typography>
                  </div>
                  {row?.name === "Kyc" && (
                    <div className="display-1 verify-stat gap-5">
                      {userData?.kyc_verify == "false" ? (
                        <>
                          <InfoOutlinedIcon
                            sx={{
                              fontSize: "15px",
                              color: "orange !important",
                            }}
                          />
                          <span>Unverified</span>
                        </>
                      ) : (
                        <>
                          <Verified />
                          <span>Verified</span>
                        </>
                      )}
                    </div>
                  )}
                </NavLink>
              );
            }
          })}
        </div>
      </Popover>
    </Box>
  );
}
export default DrawerAppBar;
